if (!customElements.get('b2b-add-to-cart')) {
  class B2BAddToCart extends HTMLElement {
    constructor() {
      super();
      this.card = this.closest('.b2b-product-card');
      if (!this.card) return;
      this.form = this.card.querySelector('form.b2b-card-right');
      if (!this.form) return;
      this.cartDrawer = document.querySelector('cart-drawer');
      this.loadingSpinner = this.querySelector('.loading-spinner');
      this.spans = this.querySelectorAll('span:not(.loading__spinner)');
      this.quantityStep = this.form.querySelector('input[name="properties[_b2b_quantity_step]"]')?.value;
      this.discountAmount = this.form.querySelector('input[name="properties[_b2b_discount_amount]"]')?.value;
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    onClick = async () => await this.addToCart();

    addToCart = async () => {
      this.toggleLoadingSpinner();
      let formData = new FormData(this.form);
      formData.append('properties[_b2b_product]', true);
      formData.append('properties[_b2b_quantity_step]', this.quantityStep || 1);
      formData.append(
        'sections',
        this.cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      formData.append('properties[_b2b_discount_amount]', this.discountAmount);
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        console.error('Error adding to cart');
      }
      const data = await response.json();
      this.cartDrawer.renderContents(data, true);
      this.toggleLoadingSpinner();
    };
    toggleLoadingSpinner = () => {
      this.loading = !this.loading;
      this.spans.forEach((span) => span.classList.toggle('hidden'));
      this.loadingSpinner.classList.toggle('hidden');
    };
  }
  customElements.define('b2b-add-to-cart', B2BAddToCart);
}
